// extracted by mini-css-extract-plugin
export default {"contactsList":"ContactList_contactsList__mDEYL"};